import React from 'react';
import Proptypes from 'prop-types';
import { Box } from '@material-ui/core';

import StandardModal from '~/components/Modal';
import RoomForm from './roomForm';

export default function AddRoomDialog({ closeCallback }) {
  return (
    <StandardModal
      title="Adicionar Sala"
      onClose={closeCallback}
      isOpened
      maxWidth="sm"
      showDividers={false}
      slideTo="left"
      fullWidth
    >
      <Box
        width={1}
        className="h-100"
        display="flex"
        alignItems="flex-start"
        justifyContent="center"
        flexDirection="column"
        pt={5}
      >
        <RoomForm handleClose={closeCallback} />
      </Box>
    </StandardModal>
  );
}

AddRoomDialog.propTypes = {
  closeCallback: Proptypes.func.isRequired,
};
